import { Box, Button, Stack, Typography } from "@mui/material";
import CustomDialog from "global/components/CustomDialog/CustomDialog";

interface CustomProps {
  showDialogModal: boolean;
  setShowDialogModal: Function;
  unexecutedCampaigns: number;
  setUnexecutedCampaigns: Function;
  handleDisconnect: Function;
}

const UnexecutedCampaignsAlertModal = (props: CustomProps) => {
  const handleCloseModel = () => {
    props.setUnexecutedCampaigns(0);
    props.setShowDialogModal(false);
  };

  const dialogTitleContent = () => {
    return (
      <>
        <Typography variant="h4" color="text.primary" textAlign="center">
          Confirmation
        </Typography>
      </>
    );
  };

  const dialogBody = () => {
    return (
      <>
        <Typography variant="body1" textAlign="center">
          You have{" "}
          <span style={{ fontWeight: 700 }}>{props.unexecutedCampaigns}</span>{" "}
          unexecuted campaigns. Clicking on disconnect would delete the
          unexecuted campaigns. Are you sure you want to disconnect?
        </Typography>
      </>
    );
  };

  const dialogFooterContent = () => {
    return (
      <>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
        >
          <Button
            id="cancel"
            size="small"
            variant="outlined"
            color="inherit"
            onClick={() => handleCloseModel()}
          >
            Cancel
          </Button>
          <Button
            id="disconnect"
            size="small"
            variant="contained"
            onClick={() => props.handleDisconnect()}
          >
            Disconnect
          </Button>
        </Stack>
      </>
    );
  };

  return (
    <>
      <CustomDialog
        isDialogOpen={props.showDialogModal}
        closable
        closeButtonVisibility
        handleDialogClose={handleCloseModel}
        title={dialogTitleContent()}
        body={dialogBody()}
        footer={dialogFooterContent()}
        width="md"
      />
    </>
  );
};

export default UnexecutedCampaignsAlertModal;
